<template>
  <div>
    <v-text-field
      :value="value.title"
      label="Section Title"
      outlined
      dense
      @input="update('title', $event)"
    />
    <div class="mb-2 font-weight-medium">Logos (Images)</div>
    <v-card v-for="(logo, i) in logos" :key="i" outlined class="mb-2 pa-3">
      <image-uploader
        :value="logo"
        :label="'Logo ' + (i + 1)"
        @input="updateLogo(i, $event)"
      />
      <v-btn text small color="error" class="mt-2" @click="removeLogo(i)">
        <v-icon small left>mdi-delete</v-icon>Remove
      </v-btn>
    </v-card>
    <v-btn text small color="primary" @click="addLogo">
      <v-icon small left>mdi-plus</v-icon>Add Logo
    </v-btn>
  </div>
</template>

<script>
import ImageUploader from "./ImageUploader.vue";

export default {
  components: { ImageUploader },
  props: {
    value: { type: Object, default: () => ({}) },
  },
  computed: {
    logos() {
      return this.value.logos || [];
    }
  },
  methods: {
    update(key, val) {
      this.$emit("input", { ...this.value, [key]: val });
    },
    updateLogo(index, url) {
      var newLogos = [...this.logos];
      newLogos[index] = url;
      this.$emit("input", { ...this.value, logos: newLogos });
    },
    addLogo() {
      this.$emit("input", { ...this.value, logos: [...this.logos, ""] });
    },
    removeLogo(index) {
      var newLogos = this.logos.filter((_, i) => i !== index);
      this.$emit("input", { ...this.value, logos: newLogos });
    }
  }
};
</script>